module.exports = __webpack_public_path__ + "static/cw_logo-87e0b8a4357d6b9cc39ae8686a501c5d.png";